import { Routes, Route } from 'react-router';

import Layout from '@/components/templates/Layout';
import PermissionsWrapper from '@/components/templates/PermissionsWrapper';

import AIAgents from './AIAgents';
import { AIAgentWithSidebar } from './AIAgentWithSidebar';

const AIAgentsRouter: React.FC = () => {
  return (
    <Layout>
      <PermissionsWrapper module="brains">
        <Routes>
          <Route path="/" element={<AIAgents />} />
          <Route path="/:brainId/*" element={<AIAgentWithSidebar />} />
        </Routes>
      </PermissionsWrapper>
    </Layout>
  );
};

export default AIAgentsRouter;
